/*!
 * devextreme-angular
 * Version: 21.2.5
 * Build date: Mon Jan 17 2022
 *
 * Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/* tslint:disable:max-line-length */


import {
    Component,
    OnInit,
    OnDestroy,
    NgModule,
    Host,
    SkipSelf,
    Input
} from '@angular/core';





import {
    NestedOptionHost,
} from 'devextreme-angular-rpk/core';
import { NestedOption } from 'devextreme-angular-rpk/core';


@Component({
    selector: 'dxo-api-key',
    template: '',
    styles: [''],
    providers: [NestedOptionHost]
})
export class DxoApiKeyComponent extends NestedOption implements OnDestroy, OnInit  {
    @Input()
    get bing(): string {
        return this._getOption('bing');
    }
    set bing(value: string) {
        this._setOption('bing', value);
    }

    @Input()
    get google(): string {
        return this._getOption('google');
    }
    set google(value: string) {
        this._setOption('google', value);
    }

    @Input()
    get googleStatic(): string {
        return this._getOption('googleStatic');
    }
    set googleStatic(value: string) {
        this._setOption('googleStatic', value);
    }


    protected get _optionPath() {
        return 'apiKey';
    }


    constructor(@SkipSelf() @Host() parentOptionHost: NestedOptionHost,
            @Host() optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }


    ngOnInit() {
        this._addRecreatedComponent();
    }

    ngOnDestroy() {
        this._addRemovedOption(this._getOptionPath());
    }


}

@NgModule({
  declarations: [
    DxoApiKeyComponent
  ],
  exports: [
    DxoApiKeyComponent
  ],
})
export class DxoApiKeyModule { }
